import React, { useState, useRef } from "react";
import './ImageEditor.scss';
import ReactCrop, {
    centerCrop,
    makeAspectCrop,
   // Crop,
   // PixelCrop,
    convertToPixelCrop,
  } from 'react-image-crop';
  import { canvasPreview } from './canvasPreview';
  import { useDebounceEffect } from './useDebounceEffect';

  import 'react-image-crop/dist/ReactCrop.css';
  import preview_img from '../../../../../../styles/svg_notes/preview_default.png';
//import { editNotePart,closeAdminNoteView } from "../../../../adminSlice";
import { validateNoteImageType, validateNoteImageSize } from "../../../../adminSlice";
import { validateFileTypeNote,validateFileTypeNoteAfterCrop, validateFileSizeNote, validateFileSizeNoteAfterCrop } from '../../../../../../helper/validation';


// This is to demonstate how to make and center a % aspect crop
// which is a bit trickier so we use some helper functions.
const  centerAspectCrop = (  mediaWidth,  mediaHeight,  aspect,) => {
    return centerCrop(
      makeAspectCrop(
        {
          unit: '%',
          width: 90,
        },
        aspect,
        mediaWidth,
        mediaHeight,
      ),
      mediaWidth,
      mediaHeight,
    )
  }



const ImageEditor = (props) => {
    const [imgSrc, setImgSrc] = useState('');
    const previewCanvasRef = useRef(null);
    const imgRef = useRef(null);
    const hiddenAnchorRef = useRef(null);
    //const blobUrlRef = useRef('');
    const [crop, setCrop] = useState();
    const [completedCrop, setCompletedCrop] = useState();
    const [scale, setScale] = useState(1);
    const [rotate, setRotate] = useState(0);
    const [aspect, setAspect] = useState(16 / 9);
    

    const {dispatch} = props;


    //select files
    const onSelectFile = (e) => {
        if (e.target.files && e.target.files.length > 0) {

          //set file to state before edit
          console.log(e.target.files[0]);
          
            //validate type image
            const image = document.getElementById('note-image-file');
            console.log(image);
            const valideTypeMessage = validateFileTypeNote(image);
            
            dispatch(validateNoteImageType(valideTypeMessage));
            //validate size image
            const valideSizeMessage = validateFileSizeNote(image);
            console.log(valideTypeMessage);
            console.log(valideSizeMessage);
            console.log(e.target.files);
            dispatch(validateNoteImageSize(valideSizeMessage));

            //SET FILE TO STATE
          props.handleFileImage(e.target.files[0]);




          setCrop(undefined); // Makes crop preview update between images.
          const reader = new FileReader();

        /*  const handleLoadFile = () => {
            setImgSrc(reader.result?.toString() || '');
           let output = document.getElementById('pre-notepart-image1');
            output.src = reader.result;
          }

          reader.addEventListener('load', handleLoadFile);
*/
          //PREVIEW
          reader.onload =() => {
            let output = document.getElementById('pre-notepart-image');
            output.src = reader.result;
            //output.src = '';
            setImgSrc(reader.result?.toString() || '');
          };

          reader.readAsDataURL(e.target.files[0]);
        }
      }
      // edit image
      const handleEditImage = () => {
        //setCheckEditImg(!checkEditImg);
        props.handleCheckImageNotePart();
    
       
       }
      //set crop
    const onImageLoad = (e) => {
        if (aspect) {
          const { width, height } = e.currentTarget;
          setCrop(centerAspectCrop(width, height, aspect));
        }
      }

    //DOWNLOAD CROPFILE -NO USE- RENEW ALL NOTEVIEW!!!
/*
  async function onDownloadCropClick() {
    const image = imgRef.current;
    const previewCanvas = previewCanvasRef.current;
    if (!image || !previewCanvas || !completedCrop) {
      throw new Error('Crop canvas does not exist');
    }

    // This will size relative to the uploaded image
    // size. If you want to size according to what they
    // are looking at on screen, remove scaleX + scaleY
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    const offscreen = new OffscreenCanvas(
      completedCrop.width * scaleX,
      completedCrop.height * scaleY,
    );
    const ctx = offscreen.getContext('2d');
    if (!ctx) {
      throw new Error('No 2d context');
    }

    ctx.drawImage(
      previewCanvas,
      0,
      0,
      previewCanvas.width,
      previewCanvas.height,
      0,
      0,
      offscreen.width,
      offscreen.height,
    );
    // You might want { type: "image/jpeg", quality: <0 to 1> } to
    // reduce image size
    const blob = await offscreen.convertToBlob({
      type: 'image/jpeg',
    });

    //console.log(blob);
    // CONVERT TO FILE
    //let imageFile = new File([blob],"name");
    //console.log(imageFile);
    //dispatch(setImageFileForNotePart(blob));



    if (blobUrlRef.current) {
      URL.revokeObjectURL(blobUrlRef.current);
    }
    blobUrlRef.current = URL.createObjectURL(blob);

    if (hiddenAnchorRef.current) {
      hiddenAnchorRef.current.href = blobUrlRef.current;
      hiddenAnchorRef.current.click();
    }
  }
  */
//
useDebounceEffect(
    async () => {
      if (
        completedCrop?.width &&
        completedCrop?.height &&
        imgRef.current &&
        previewCanvasRef.current
      ) {
        // We use canvasPreview as it's much faster than imgPreview.
        canvasPreview(
          imgRef.current,
          previewCanvasRef.current,
          completedCrop,
          scale,
          rotate,
        )
      }
    },
    100,
    [completedCrop, scale, rotate],
  )
//
const handleToggleAspectClick1 = () => {
  console.log('fuckkkk');
 
    if (aspect) {
      setAspect(undefined);
    } else {
      setAspect(16 / 9);

      if (imgRef.current) {
        const { width, height } = imgRef.current;
        const newCrop = centerAspectCrop(width, height, 16 / 9);
        setCrop(newCrop);
        // Updates the preview
        setCompletedCrop(convertToPixelCrop(newCrop, width, height));
      }
    }
      
  }


//HANDLE EDIT PART NOTE
 const  handleEdit = async(e) => {
    e.preventDefault();
    //const valideTypeMessage = props.errorNoteImageValidateType;
    //const valideSizeMessage = props.errorNoteImageValidateSize;

    const image = imgRef.current;
    const previewCanvas = previewCanvasRef.current;
    if (!image || !previewCanvas || !completedCrop) {
      throw new Error('Crop canvas does not exist');
    }

    // This will size relative to the uploaded image
    // size. If you want to size according to what they
    // are looking at on screen, remove scaleX + scaleY
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    const offscreen = new OffscreenCanvas(
      completedCrop.width * scaleX,
      completedCrop.height * scaleY,
    );
    const ctx = offscreen.getContext('2d');
    if (!ctx) {
      throw new Error('No 2d context');
    }

    ctx.drawImage(
      previewCanvas,
      0,
      0,
      previewCanvas.width,
      previewCanvas.height,
      0,
      0,
      offscreen.width,
      offscreen.height,
    );
    // You might want { type: "image/jpeg", quality: <0 to 1> } to
    // reduce image size
    const blob = await offscreen.convertToBlob({
      type: 'image/jpg',
    });
    // CONVERT TO FILE
    let imageFile = new File([blob],"editFile.jpg",{
      type: "image/jpg",
    });
    //let arrayImages =[]; // vremenno array dont need here
    //arrayImages.push(imageFile);
    console.log(imageFile);
//console.log(arrayImages);

            //validate type image
            //const newImage = document.getElementById('note-image-file');
            const valideTypeMessage = validateFileTypeNoteAfterCrop(imageFile);
            
            dispatch(validateNoteImageType(valideTypeMessage));
            //validate size image
            const valideSizeMessage = validateFileSizeNoteAfterCrop(imageFile);
            console.log(valideTypeMessage);
            console.log(valideSizeMessage);
            //console.log(e.target.files);
            dispatch(validateNoteImageSize(valideSizeMessage));









    props.handleFileImage(imageFile);
    //props.handleFileImage(arrayImages);






  
  }




  //RENDER CROP EDITOR
const renderCropImage = () => {
  return (
<div >

<div className="Crop-Controls">
                
        <div>
          <label htmlFor="scale-input">Scale: </label>
          <input
            id="scale-input"
            type="number"
            step="0.1"
            value={scale}
            disabled={!imgSrc}
            onChange={(e) => setScale(Number(e.target.value))}
          />
        </div>
        <div>
          <label htmlFor="rotate-input">Rotate: </label>
          <input
            id="rotate-input"
            type="number"
            value={rotate}
            disabled={!imgSrc}
            onChange={(e) =>
              setRotate(Math.min(180, Math.max(-180, Number(e.target.value))))
            }
          />
        </div>
        <div>
          <button onClick={handleToggleAspectClick1}>
            Toggle aspect {aspect ? 'off' : 'on'}
          </button>
        </div>
      </div>
      {!!imgSrc && (
        <ReactCrop
          crop={crop}
          onChange={(_, percentCrop) => setCrop(percentCrop)}
          onComplete={(c) => setCompletedCrop(c)}
          aspect={aspect}
          // minWidth={400}
          minHeight={100}
          // circularCrop
        >
          <img
            ref={imgRef}
            alt="Crop me"
            src={imgSrc}
            style={{ transform: `scale(${scale}) rotate(${rotate}deg)` }}
            onLoad={onImageLoad}
          />
        </ReactCrop>
      )}
      {!!completedCrop && (
        <>
          <div>
            <canvas
              ref={previewCanvasRef}
              style={{
                border: '1px solid black',
                objectFit: 'contain',
                width: completedCrop.width,
                height: completedCrop.height,
              }}
            />
          </div>
          <div>
            {/*<button onClick={onDownloadCropClick}>Скачать изображение</button>*/}
            <div style={{ fontSize: 12, color: '#666' }}>
              
            </div>
            <a
              href="#hidden"
              ref={hiddenAnchorRef}
              download
              style={{
                position: 'absolute',
                top: '-200vh',
                visibility: 'hidden',
              }}
            >
              Hidden download
            </a>
          </div>
          <div>
            <button onClick={handleEdit}>Сохранить изменения</button>
            <div style={{ fontSize: 12, color: '#666' }}>
              
            </div>
            <a
              href="#hidden"
              ref={hiddenAnchorRef}
              download
              style={{
                position: 'absolute',
                top: '-200vh',
                visibility: 'hidden',
              }}
            >
              Hidden download
            </a>
          </div>
        </>
      )}
</div>
  )
}
//RENDER PREVIEW
const renderPreview = () => {
  return (
    <div>
            <img id='pre-notepart-image' src={preview_img} alt="PartNoteImage" className="previewImage"/>
    </div>
  );
}

// STYLE INPUT BUTTONS
let styleImg;
if (props.activeAdminStyle) {

  styleImg = '';
  
}
else {
  
  styleImg = 'disabled';

}
if (props.activeEditAdminStyle) {
  
  // styleEdit = 'edit-block'; // block visible
 
   styleImg = 'disabled';
  

  } 

if (props.checkImg)  {
   styleImg = '';
   
} else {
   styleImg = 'disabled';
 
}


return (
<div className="ImageEditor">
  

  <div className="Crop-Controls">
        <input id='note-image-file' type="file" accept="image/*" onChange={onSelectFile} disabled={styleImg}/>
        <p className='p-text'>Допустимые форматы -jpg, jpeg, webp. Допустимый размер файла до 0.5Мб</p>
        <fieldset>
          <legend>Редактировать изображение</legend>

           <div>
              <input type="checkbox" id="img-part-note1" name="img" value={props.checkEditImg} onChange={handleEditImage} checked={props.checkEditImg} disabled={styleImg}/>
                <label htmlFor="img"></label>
                <p className='err-text'>{props.errorNoteImageValidateSize}</p>
                <p className='err-text'>{props.errorNoteImageValidateType}</p>
           </div> 
         </fieldset>
         {renderPreview()}
         {props.checkEditImg ? renderCropImage(): null}
       
  </div>
 
</div>

);
  
};
export default ImageEditor;